import { Theme } from "@mui/material";

export const styledPdfCardItem = {
  display: 'flex',
  flexDirection: 'column'
};

export const styledPdfCardActionAerea = {
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: (theme: Theme) => theme.palette.grey[300],
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  background: (theme: Theme) => theme.palette.grey[300],
};

export const styledPdfCardContent = {
  display: 'flex',
  flexDirection:'column',
  flex:1,
  p:1,
  width: '100%',
  background: 'white',
};

export const styledPdfCardTitle = {
  fontWeight: '600',
  flexGrow: 1,
};

export const styledPdfCardActions = {
  p: 0,
};

export const styledPdfCardActionsBtn = {
  paddingTop: (theme: Theme) => theme.spacing(1.25),
  paddingBottom: (theme: Theme) => theme.spacing(1.25),
};

export const styledPdfCardActionsBtnIcon = {
  display: 'inline-flex',
  fontSize: 18,
};

export const styledPdfCardActionsBtnGroup = {
  '.MuiButtonGroup-grouped:not(:first-of-type)': {
    borderTopRightRadius: 0,
  },
  '.MuiButtonGroup-grouped:not(:last-of-type)': {
    borderTopLeftRadius: 0,
  },
};

export const styledPdfCardValidity = {
  textAlign: 'right',
  fontWeight: '600',
  color: (theme: Theme) => theme.palette.grey[500],
  fontSize: 12,
};

export const styledPdfCardLabel = {
  position: 'absolute',
  top: 10,
  right: 0,
  zIndex: 1,
};

export const styledNewPdfFile = {
  borderRadius: '4px 0 0 4px',
  fontWeight: '600',
};

export const styledValidedPdfFile = {
  borderRadius: '4px 0 0 4px',
  '.MuiChip-label':{
    display:'inline-flex',
    alignItems:'center',    
  },
  '.MuiSvgIcon-root': {
    fontSize: '20px',
  },
  '.MuiBox-root':{
    ml:1,
  },
};

export const styledDownloadedPdfFile = {
  borderRadius: '4px 0 0 4px',
  backgroundColor: 'green',
  '.MuiSvgIcon-root': {
    fontSize: '20px',
  },
};


